import React from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeStore } from '../../stores/themeStore';
import { GRADIENT_ACCENTS } from '../../theme';

interface StyleScoreBadgeProps {
  score: number;
  size?: 'small' | 'medium';
}

/**
 * StyleScoreBadge — circular badge with gradient background showing
 * the aggregate outfit rating alongside a fire emoji.
 */
const StyleScoreBadge: React.FC<StyleScoreBadgeProps> = ({
  score,
  size = 'medium',
}) => {
  const palette = useThemeStore((s) => s.palette);
  const gradient = GRADIENT_ACCENTS[palette].primary;
  const dim = size === 'small' ? 36 : 48;
  const fontSize = size === 'small' ? '0.7rem' : '0.85rem';
  const emojiSize = size === 'small' ? '0.65rem' : '0.75rem';

  const displayScore = score > 0 ? score.toFixed(1) : '—';

  return (
    <Box
      aria-label={`Style score: ${displayScore}`}
      sx={{
        width: dim,
        height: dim,
        borderRadius: '50%',
        background: gradient,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        flexShrink: 0,
      }}
    >
      <Typography
        component="span"
        sx={{
          color: '#fff',
          fontWeight: 700,
          fontSize,
          lineHeight: 1.1,
        }}
      >
        {displayScore}
      </Typography>
      <Typography component="span" sx={{ fontSize: emojiSize, lineHeight: 1 }}>
        🔥
      </Typography>
    </Box>
  );
};

export default StyleScoreBadge;
